module.exports = __webpack_public_path__ + "static/img/prize_1.6520ae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/winterOlympics/dialog/prize_1.png
// module id = HcUp
// module chunks = 33